import { cn } from "@/lib/utils"

interface SectionProps {
  id: string
  title: string
  children: React.ReactNode
  className?: string
}

export function Section({ id, title, children, className }: SectionProps) {
  return (
    <section id={id} className={cn("scroll-mt-20", className)}>
      <h2 className="group relative">
        {title}
        <a
          href={`#${id}`}
          className="ml-2 text-indigo-600 opacity-0 transition-opacity group-hover:opacity-100 dark:text-indigo-400"
          aria-label={`Link to ${title}`}
        >
          #
        </a>
      </h2>
      <div className="space-y-4">{children}</div>
    </section>
  )
}
